import {
  transform,
  cloneDeep,
  variable,
  num,
  mul,
  add,
  type ExprNode,
} from '@learnforge/demo-math/expr';

export function substitute(node: ExprNode, varName: string, value: ExprNode): ExprNode {
  return transform(node, (sub) =>
    sub.kind === 'var' && sub.name === varName ? cloneDeep(value) : sub,
  );
}

export function transformExpression(
  base: ExprNode,
  params: { a: number; b: number; h: number; k: number },
): ExprNode {
  // a · f(b·(x − h)) + k
  const inner = mul([num(params.b), add([variable('x'), num(-params.h)])]); // b·(x − h)
  const substituted = substitute(base, 'x', inner);
  const scaled = mul([num(params.a), substituted]);
  return add([scaled, num(params.k)]);
}

export function composeExpressions(f: ExprNode, g: ExprNode): ExprNode {
  return substitute(f, 'x', g);
}
